export interface ReportCard {
  id: string;
  title: string;
  description: string;
  icon: string;
  iconBg: string;
  iconColor: string;
}

/**
 * Static report navigation tiles — these are UI navigation, not data.
 * The reports themselves (low stock, damage, etc.) will pull live data
 * from the relevant stores when each report page is wired up.
 */
export const reportCards: ReportCard[] = [
  { id: 'low-stock', title: 'Low Stock Report', description: 'View all items below minimum threshold', icon: 'lowStock', iconBg: '#FFF7ED', iconColor: '#F97316' },
  { id: 'damage', title: 'Damage Report', description: 'Track all damaged inventory items', icon: 'damage', iconBg: '#FEF2F2', iconColor: '#EF4444' },
  { id: 'shrink', title: 'Shrink Report', description: 'Monitor inventory shrinkage and losses', icon: 'shrink', iconBg: '#F5F3FF', iconColor: '#7C3AED' },
  { id: 'inventory-movement', title: 'Inventory Movement Report', description: 'Track all inventory transactions', icon: 'movement', iconBg: '#EFF6FF', iconColor: '#3B82F6' },
  { id: 'picking-performance', title: 'Picking Performance Report', description: 'Analyze picking efficiency and speed', icon: 'picking', iconBg: '#F0FDF4', iconColor: '#16A34A' },
];
